import Vue from 'vue';
import Vuex from 'vuex';
import { db, storage }  from '../main';

//import firebase from 'firebase';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    uidUser:'',
    dolar:0,
    uf:0,
    utm:0,
    euro:0, 
    ipc:0,
    actividades:[],
    busqueda:'',
    clientes:[],
    factordeplanta:{},
    distribuidora:{},
    tarifa:{},
    paneles:[],
    inversores:[],
    CantidadAnalisis:[],
    idCliente:'',
    analisisDatosCliente:'' , // se utilizara para almacenar los datos del cliente  y ver el análisis específico de un cliente
    analisisDatosAnalisis:'', // se utilizara para almacenar los datos de la parte de analisis del  cliente  y ver el análisis específico de un cliente
    DiagnosticoTarifarioX43:0, // Valor del total anual del análisis tarifario Tarifa X.4.3. 
    DiagnosticoTarifarioX42:0, // Valor del total anual del análisis tarifario Tarifa X.4.2. 
    DiagnosticoTarifarioX41:0, // Valor del total anual del análisis tarifario Tarifa X.4.1. 
    DiagnosticoTarifarioX3:0, // Valor del total anual del análisis tarifario Tarifa X.3. 
    DiagnosticoTarifarioX2:0, // Valor del total anual del análisis tarifario Tarifa X.2. 


    SeguimientoProyectos:[] //actividades realizadas a los clientes que pasaron de Propuuesta a Proyecto
  },
  //************************************************************************ */
  getters:{
    enviandousuario(state) {
      return state.uidUser; 
    },
    enviarDataClientes(state){
      return state.clientes; 
    },
    enviarDataFactorPlanta(state){
      return state.factordeplanta;
    },
    enviarDataDistribuidora(state){
      return state.distribuidora;
    },
    enviarDataTarifa(state){
      return state.tarifa;
    },
    enviarDataPaneles(state){
      return state.paneles;
    },
    enviarDataActividades(state){
      return state.actividades;
    },
    enviarDataInversores(state){
      return state.inversores;
    },
    enviarDataAnalisis(state){
      return state.CantidadAnalisis; 
    },
    enviarVerAnalisis_cliente(state){
      return state.analisisDatosCliente; 
    },
    enviarIdCliente(state){
      return state.idCliente; 
    },
    enviarDataDetalleAnalisis(state){  // se envia datos del detalle del análisis a verAnalisis
      return state.analisisDatosAnalisis;
    },
    enviarDataSeguimientoProyectos(state){ // detalle de las actividades realizadas al proyecto para la instalación de la p f.v.
      return state.SeguimientoProyectos;
    }
  },
  //************************************************************************ */
  mutations: {
    accesoUsuario_mutation(state, datosUsuario ) {    
      state.uidUser = datosUsuario;  
      },
    llamarclientes(state){
      db.collection("clientes").orderBy('nombre').onSnapshot(datos=> {
        let auxiliar =[];
        datos.forEach((element) => {
          auxiliar.push({
            nombre: element.data().nombre,
            direccion: element.data().direccion,
            fp:element.data().fp,
            representante: element.data().representante,
            rut: element.data().rut,
            telefono: element.data().telefono,
            distribuidora: element.data().distribuidora,
            potencia: element.data().potencia,
            tarifa: element.data().tarifa,
            numerocliente: element.data().numerocliente,
            costoCLP_KWh: element.data().costoCLP_KWh,
            costoCLP_transporte: element.data().costoCLP_transporte,
            precioCLP_excedente: element.data().precioCLP_excedente,
            boleta: element.data().boleta,
            aporte: element.data().aporte,
            estado:element.data().estado,
            valordolar: element.data().valordolar,
            idDoc: element.id
          })
        })
        state.clientes = auxiliar;
      })
    },
    llamarAnalisis(state, idDoc){  
      db.collection("clientes").doc(idDoc).collection("analisis").onSnapshot(datos => {
        let auxiliar= [];
        datos.forEach((element)=> {          
          auxiliar.push({     
            idCliente: element.data().idCliente,     
            tamanoplantacotizar: element.data().tamanoplantacotizar,
            valordolarcotizar: element.data().valordolarcotizar,
            valorecer: element.data().valorecer,
            pie: element.data().pie,
            tasa: element.data().tasa,
            plazoanos: element.data().plazoanos,
            panel: element.data().panel,
            inversor: element.data().inversor,
            lugarinstalacion: element.data().lugarinstalacion,
            fecha: element.data().fecha,
            idDoc: element.id
          })
        })
        state.CantidadAnalisis = auxiliar;        
      })
    },
    pasarIdCliente(state, idrecibido){
        state.idCliente = idrecibido;     
    },
    AnalisisDataCliente(state, idDoc){  // se busca en la base de datos al cliente para mostrar en VerAnalisis
      state.analisisDatosCliente='',      
        db.collection("clientes").doc(idDoc).get().then(response =>{
          state.analisisDatosCliente = response.data();          
        })         
    },
    AnalisisDataAnalisis(state, idsRecibidos){  // se busca en la base de datos los datos del analisis para el cliente para mostrar en VerAnalisis
      state.analisisDatosAnalisis='';
        db.collection("clientes").doc(idsRecibidos.idCliente).collection("analisis").doc(idsRecibidos.idDocAnalisis).get().then(response =>{
          state.analisisDatosAnalisis = response.data();
        })         
    },

    llamarfactorplanta(state){
      db.collection("fp").orderBy('text').onSnapshot(datos=> {
        let auxiliar =[];
        datos.forEach((element) => {
          auxiliar.push({
            text: element.data().text,
            value: element.data().value,
            idDoc: element.id
          })
        })
        state.factordeplanta = auxiliar;
      })
    },
    llamardistribuidora(state){
      db.collection("distribuidora").orderBy('text').onSnapshot(datos=> {
        let auxiliar =[];
        datos.forEach((element) => {
          auxiliar.push({
            text: element.data().text,
            value: element.data().value,
            idDoc: element.id
          })
        })
        state.distribuidora = auxiliar;
      })
    },    
    llamartarifa(state){
      db.collection("tarifa").orderBy('text').onSnapshot(datos=> {
        let auxiliar =[];
        datos.forEach((element) => {
          auxiliar.push({
            text: element.data().text,
            value: element.data().value,
            idDoc: element.id
          })
        })
        state.tarifa = auxiliar;
      })
    },


    grabarCliente(state, informaciongrabarCliente){
      db.collection("clientes").add ({
        nombre: informaciongrabarCliente.nombre,
        //imgurl:informaciongrabarCliente.img,
        direccion: informaciongrabarCliente.direccion,
        fp:informaciongrabarCliente.fp,
        representante: informaciongrabarCliente.representante,
        rut: informaciongrabarCliente.rut,
        telefono: informaciongrabarCliente.telefono,
        distribuidora: informaciongrabarCliente.distribuidora,
        potencia: informaciongrabarCliente.potencia,
        tarifa: informaciongrabarCliente.tarifa,
        numerocliente: informaciongrabarCliente.numerocliente,
        costoCLP_KWh: informaciongrabarCliente.costoCLP_KWh,
        costoCLP_transporte: informaciongrabarCliente.costoCLP_transporte,
        precioCLP_excedente: informaciongrabarCliente.precioCLP_excedente,
        boleta: informaciongrabarCliente.boleta,
        aporte: informaciongrabarCliente.aporte,
        estado:informaciongrabarCliente.estado,
        valordolar: informaciongrabarCliente.valordolar,
        imageUrl: informaciongrabarCliente.imageUrl
      })
      state.clientes.unshift(informaciongrabarCliente);
    },
    editarDatosCliente(state, datoseditarDatosCliente){
      db.collection("clientes").doc(datoseditarDatosCliente.idDoc).update({
        nombre: datoseditarDatosCliente.nombre,
        direccion: datoseditarDatosCliente.direccion,
        fp: datoseditarDatosCliente.fp,
        representante: datoseditarDatosCliente.representante,
        rut: datoseditarDatosCliente.rut,
        telefono: datoseditarDatosCliente.telefono
      })
    },
    editarDatosDistribuidora(state, datoseditarDatosDistribuidora){
      db.collection('clientes').doc(datoseditarDatosDistribuidora.idDoc).update({
        distribuidora: datoseditarDatosDistribuidora.distribuidora,
        potencia: datoseditarDatosDistribuidora.potencia,
        tarifa: datoseditarDatosDistribuidora.tarifa,
        numerocliente: datoseditarDatosDistribuidora.numerocliente,
        costoCLP_KWh: datoseditarDatosDistribuidora.costoCLP_KWh,
        costoCLP_transporte: datoseditarDatosDistribuidora.costoCLP_transporte,
        precioCLP_excedente: datoseditarDatosDistribuidora.precioCLP_excedente
      })
    },
    editarDatosConsumo(state, datoseditarDatosConsumo){      
      db.collection('clientes').doc(datoseditarDatosConsumo.idDoc).update({
        boleta: datoseditarDatosConsumo.datos
      })
    },


    llamarpaneles(state){
      db.collection("paneles").orderBy('Item').onSnapshot(datos=> {
        let auxiliar =[];
        datos.forEach((element) => {
          auxiliar.push({
            Item: element.data().Item,
            Marca: element.data().Marca,
            Procedencia: element.data().Procedencia,
            Modelo: element.data().Modelo,
            Potencia: element.data().Potencia,
            Rendimiento: element.data().Rendimiento,
            Celulas: element.data().Celulas,
            Peso: element.data().Peso,
            Dimensiones: element.data().Dimensiones,
            Tipo: element.data().Tipo,
            Resolucion: element.data().Resolucion,
            idDoc: element.id
          })
        })        
        state.paneles = auxiliar;
      })      
    },
    llamarinversores(state){      
      db.collection("inversores").orderBy('Item').onSnapshot(datos=> {
        let auxiliar =[];
        datos.forEach((element) => {
          auxiliar.push({
            Item: element.data().Item,
            Marca: element.data().Marca,
            Procedencia: element.data().Procedencia,
            Modelo: element.data().Modelo,
            Potencia: element.data().Potencia,
            Rendimiento: element.data().Rendimiento,
            Peso: element.data().Peso,
            Dimensiones: element.data().Dimensiones,
            Resolucion: element.data().Resolucion,
            idDoc: element.id
          })
        })        
        state.inversores = auxiliar;
      })                 
    },
    guardarAnalisis(state, informacionguardarAnalisis){
      db.collection("clientes").doc(informacionguardarAnalisis.idDoc).collection('analisis').add ({      
          idCliente: informacionguardarAnalisis.idCliente,  
          fecha: informacionguardarAnalisis.fecha,
          tamanoplantacotizar: parseFloat(informacionguardarAnalisis.tamanoplantacotizar),          
          valordolarcotizar: parseFloat(informacionguardarAnalisis.valordolarcotizar),
          valorecer: informacionguardarAnalisis.valorecer,
          pie: informacionguardarAnalisis.pie,
          tasa: informacionguardarAnalisis.tasa,
          plazoanos: informacionguardarAnalisis.plazoanos,
          panel: informacionguardarAnalisis.panel,
          inversor: informacionguardarAnalisis.inversor,
          lugarinstalacion: informacionguardarAnalisis.lugarinstalacion  
      })
      
    },
    convertiraProyecto(state, idDoc){  //pasa una Propuesta a Proyecto
      db.collection("clientes").doc(idDoc).update({
        estado:'Proyecto'
      })
    },
    llamaractividades(state){
      db.collection("actividades").orderBy('text').onSnapshot(datos=> {
        let auxiliar =[];
        datos.forEach((element) => {
          auxiliar.push({
            text: element.data().text,
            value: element.data().value,
            idDoc: element.id
          })
        })
        state.actividades = auxiliar;
      })
    },
    guardarSeguimiento(state, informacionguardarSeguimiento){      
      db.collection("SeguimientoProyectos").add ({
        //idDocCliente: informacionguardarSeguimiento.idDocCliente,
        fecha: informacionguardarSeguimiento.fecha,
        nombreinforme: informacionguardarSeguimiento.nombreinforme,
        nombreproyecto: informacionguardarSeguimiento.nombreproyecto,
        descripcionactividad: informacionguardarSeguimiento.descripcionactividad,
      })

    },
    llamarseguimientoactividades(state){
      db.collection("SeguimientoProyectos").orderBy("fecha").onSnapshot(datos=> {
        let auxiliar =[];
        datos.forEach((element) => {
          auxiliar.push({
            //idDocCliente:  element.data().idDocCliente,
            fecha:  element.data().fecha,
            nombreinforme: element.data().nombreinforme,
            nombreproyecto:  element.data().nombreproyecto,
            descripcionactividad:  element.data().descripcionactividad,
            idDoc: element.id
          })          
        })
        state.SeguimientoProyectos = auxiliar;

        //console.log(state.SeguimientoProyectos);
      })
    },
    verseguimiento(state, dataverseguimiento){
      console.log(dataverseguimiento);
      // Create a storage reference from our storage service
      
      const storageRef=storage.ref('/imagenes/'+dataverseguimiento.name).put(dataverseguimiento);      
      console.log(storageRef); 
      

      //firebase.storage().ref(`${dataverseguimiento.name}`).put(dataverseguimiento.name);
      //storageRef('/imagenes/'+dataverseguimiento.name);
      //const storageRef=storage.ref('/imagenes/'+dataverseguimiento.name).put(dataverseguimiento.imageData);
    }

    
    // grabacioninversores(state, datosgrabacion){
      
      
    //    db.collection('inversores').add({
    //      Item: datosgrabacion.Item,
    //      Marca: datosgrabacion.Marca,
    //      Procedencia: datosgrabacion.Procedencia,
    //      Modelo: datosgrabacion.Modelo,
    //      Potencia: datosgrabacion.Potencia,
    //      Rendimiento: datosgrabacion.Rendimiento,
    //      Peso: datosgrabacion.Peso,
    //      Dimensiones: datosgrabacion.Dimensiones,
    //      Resolucion: datosgrabacion.Resolucion
    //    }) 
    // }
   
  },
  //************************************************************************ */
  actions: {
    accesoUsuario(context,datosUsuario){            
      context.commit('accesoUsuario_mutation', datosUsuario)
    },
    llamarclientes(context){
      context.commit('llamarclientes'); 
    },
    llamarAnalisis(context, idDoc){   // Busca la cantidad de análisis que pueda tener este cliente si es 0 va a la ruta /analisis
      context.commit('llamarAnalisis', idDoc);
    },
    llamarfactorplanta(context){
      context.commit('llamarfactorplanta'); 
    },
    llamardistribuidora(context){
      context.commit('llamardistribuidora'); 
    },
    llamartarifa(context){
      context.commit('llamartarifa'); 
    },
    grabarCliente(context, datagrabarCliente){
      context.commit('grabarCliente', datagrabarCliente);
    },
    editarDatosCliente(context, datoseditarDatosCliente){
      context.commit('editarDatosCliente', datoseditarDatosCliente)
    },
    editarDatosDistribuidora(context, datoseditarDatosDistribuidora){
      context.commit('editarDatosDistribuidora', datoseditarDatosDistribuidora); 
    },
    editarDatosConsumo(context, datoseditarDatosConsumo) {
      context.commit('editarDatosConsumo', datoseditarDatosConsumo)    
    },

    // grabacioninversores(context, parametrosgrabacion){
    //   context.commit('grabacioninversores', parametrosgrabacion);
    // },

    llamarpaneles(context,parametrosllamarpaneles){
      context.commit('llamarpaneles', parametrosllamarpaneles);
    },
    llamarinversores(context,parametrosllamarinversores){
      context.commit('llamarinversores', parametrosllamarinversores);
    },
    guardarAnalisis(context,parametrosguardarAnalisis){
      context.commit('guardarAnalisis', parametrosguardarAnalisis)
    },
    pasarIdCliente(context,id){      
      context.commit('pasarIdCliente', id);       
    },
    AnalisisDataCliente(context,id){
      context.commit('AnalisisDataCliente', id);
    },
    AnalisisDataAnalisis(context, parametrosAnalisisDataAnalisis){
      context.commit('AnalisisDataAnalisis', parametrosAnalisisDataAnalisis)
    },
    convertiraProyecto(context, idDoc){  
      context.commit('convertiraProyecto', idDoc)
    },
    llamaractividades(context){
      context.commit('llamaractividades')
    },
    guardarSeguimiento(context, parametrosguardarSeguimiento){
      context.commit('guardarSeguimiento', parametrosguardarSeguimiento);
    },
    llamarseguimientoactividades(context){
      context.commit('llamarseguimientoactividades');
    },
    subirimagenLogo(context,parametro){
      context.commit('subirimagenLogo', parametro);     
    },
    verseguimiento(context, parametrosverseguimiento){
      context.commit('verseguimiento', parametrosverseguimiento)
    }


  },
  //************************************************************************ */
  modules: {
    
  }
  //************************************************************************ */
})
